export const MarketplacePostWarningXTimes = 'MarketPlace_Post_Warning_XTimes';
export const LoadStopRefs = 'LoadStopRefs';
